import React, { Component } from "react";
import "./NotFound.scss";

class NotFound extends Component {
  render() {
    return (
      <div className="container">
        <p>This is the NotFound page.</p>
        <p>Content for the NotFound page lives here.</p>
      </div>
    );
  }
}

export default NotFound;
